import { render } from "./SidebarShopingCart.vue?vue&type=template&id=1d52d131&scoped=true"
import script from "./SidebarShopingCart.vue?vue&type=script&lang=js"
export * from "./SidebarShopingCart.vue?vue&type=script&lang=js"

import "./SidebarShopingCart.vue?vue&type=style&index=0&id=1d52d131&scoped=true&lang=css"
import "./SidebarShopingCart.vue?vue&type=style&index=1&id=1d52d131&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d52d131"]])

export default __exports__